package org.multipaz.device

enum class AndroidKeystoreSecurityLevel {
    SOFTWARE,
    TRUSTED_ENVIRONMENT,
    STRONG_BOX
}